<template>
  <main class="main configurations">
    <div class="white-panel">
      <header class="panel-header">
        <router-link
          :to="{name: 'ServiceSettingsPage', params: { serviceID: serviceID }}"
          type="button"
          class="step-back"
          :aria-label="$t('step.back')"
          :title="$t('step.back')"
        />
        <h2 class="panel-title">
          {{ $t('general.settings') }}
        </h2>
      </header>
      <div
        v-if="service"
        class="config-panel panel-scroll"
      >
        <div class="row space-between">
          <div>
            <div class="config-label">
              {{ $t('service') }}
            </div>
            <div class="config-description">
              {{ $t('service.switch.description') }}
            </div>
            <div
              :class="{ 'config-error__disabled': !switchLocked }"
              class="config-error"
            >
              {{ $t('service.switch.error') }}
            </div>
          </div>
          <div>
            <div class="switch">
              <input
                id="service-status"
                v-model="service.active"
                :checked="service.active"
                type="checkbox"
                class="btn-checkbox btn-switch checkbox-focus"
                @change="stateServiceChange"
              >
              <label
                for="service-status"
                class="switch-label"
              >
                <span
                  class="switch-status switch-status__on"
                  aria-hidden="true"
                >{{ $t('on') }}</span>
                <span
                  class="switch-status switch-status__off"
                  aria-hidden="false"
                >{{ $t('off') }}</span>
              </label>
            </div>
          </div>
        </div>
        <div
          :disabled="!service.active"
          class="row space-between"
        >
          <div>
            <div class="config-label">
              {{ $t('print.tickets') }}
            </div>
            <div class="config-description">
              {{ $t('print.tickets.description') }}
            </div>
          </div>
          <div>
            <div class="switch">
              <input
                id="print-tickets"
                v-model="service.printer"
                type="checkbox"
                class="btn-checkbox btn-switch checkbox-focus"
                @change="statusPrintTickets"
              >
              <label
                for="print-tickets"
                class="switch-label"
              >
                <span
                  class="switch-status switch-status__on"
                  aria-hidden="true"
                >{{ $t('active') }}</span>
                <span
                  class="switch-status switch-status__off"
                  aria-hidden="false"
                >{{ $t('inactive') }}</span>
              </label>
            </div>
          </div>
        </div>
        <div
          :disabled="!service.active || !service.printer"
          class="row space-between"
        >
          <div>
            <div class="config-label">
              {{ $t('online.tickets') }}
            </div>
            <div class="config-description">
              {{ $t('online.tickets.description') }}
            </div>
          </div>
          <div>
            <div class="switch">
              <input
                id="online-tickets"
                v-model="service.online"
                type="checkbox"
                class="btn-checkbox btn-switch checkbox-focus"
                @change="statusOnlineTickets"
              >
              <label
                for="online-tickets"
                class="switch-label"
              >
                <span
                  class="switch-status switch-status__on"
                  aria-hidden="true"
                >{{ $t('active') }}</span>
                <span
                  class="switch-status switch-status__off"
                  aria-hidden="false"
                >{{ $t('inactive') }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import api from '@/api'
export default {
  props: {
    serviceID: {
      type: String,
      required: true
    },
    socket: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      switchLocked: false
    }
  },
  computed: {
    ...mapState(['service', 'loggedUser'])
  },
  async created () {
    this.socket.on('connect', () => {
      this.socket.emit('join-service-settings', {
        service: this.serviceID
      })
    })
    await this.fetchService(this.serviceID)
  },
  async mounted () {
    this.socket.on(`${this.serviceID}-status-update`, async ({ service }) => {
      await this.updateServiceStatus(service)
    })
  },
  beforeDestroy () {
    this.socket.disconnect()
  },
  methods: {
    ...mapActions(['fetchService', 'updateServiceStatus']),
    async stateServiceChange () {
      try {
        await api.changeServiceStatus({
          service: this.serviceID,
          active: this.service.active
        })
        this.switchLocked = false
      } catch (error) {
        this.switchLocked = true
      }
      await this.fetchService(this.serviceID)
    },
    async statusPrintTickets () {
      await api.statusPrintTickets({
        service: this.serviceID,
        printer: this.service.printer
      })
      await this.fetchService(this.serviceID)
    },
    async statusOnlineTickets () {
      await api.statusOnlineTickets({
        service: this.serviceID,
        online: this.service.online
      })
      await this.fetchService(this.serviceID)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
.config-error {
  margin-top: 10px;
  color: $red;
}

.config-error__disabled {
  display: none;
}
</style>
